import { FieldMaskCreationFilterFn, FieldMaskCreationFilterPresets, FieldMaskEntry } from './types';

export const FIELD_MASK_CREATION_FILTER_PRESETS: Record<FieldMaskCreationFilterPresets, FieldMaskCreationFilterFn> = {
  'remove-nullish': <T extends object>({ value }: FieldMaskEntry<T>) => value !== undefined && value !== null,
  'remove-falsy': <T extends object>({ value }: FieldMaskEntry<T>) => !!value,
  'preserve-all': () => true,
};
